import React from 'react';

const APP_STORE_LINK = 'itms-apps://itunes.apple.com/us/app/apple-store/6445992216?mt=8';
const PLAY_STORE_LINK = 'https://play.google.com/store/apps/details?id=com.looko.aclosetbusiness';

/**
 * 앱 스토어 이동 처리 훅
 *
 * Looko AI 앱으로 이동을 시도하고, 실패 시 앱 다운로드 페이지로 리다이렉션합니다.
 * - iOS: App Store 링크
 * - Android: Play Store 링크
 * - 앱 설치 여부에 따른 딥링크 처리
 * - 2초 타임아웃 후 스토어 페이지로 이동
 *
 * @returns 앱 스토어 이동 핸들러 함수
 */
export const useAppStoreHandler = () => {
  return React.useCallback(() => {
    const userAgent = navigator.userAgent || '';
    let storeLink: string = '';

    // iOS
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      storeLink = APP_STORE_LINK;
    }

    // Android
    if (/android/i.test(userAgent)) {
      storeLink = PLAY_STORE_LINK;
    }

    if (storeLink) {
      const close = setTimeout(() => {
        window.location.href = storeLink;
      }, 2000);

      if (document.hidden) {
        clearTimeout(close);
      }

      window.location.href = 'aclosetbusiness://';
    }
  }, []);
};
